import { useOutletContext } from 'react-router-dom'

import ExpensesList from 'modules/expenses/components/expenses/List'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'
import { usePageDateFilters } from 'modules/expenses/lib/PageDateFiltersContext'
import type { TabRouteContextParams } from 'modules/expenses/lib/RouteContextParams'
import { EXPENSES_SYNC_CONFIGURATION } from 'modules/expenses/pages/SyncConfiguration'
import { IntegrationsSyncContextProvider } from 'modules/integrations/public'

const ExpensesListTab = () => {
  const { employeeIds, onAddUsers, addUsersDisabled } = useOutletContext<TabRouteContextParams>()
  const { navigation } = useExpensesNavigation()
  const { dateFilters, setPageDateFilters } = usePageDateFilters()

  return (
    <IntegrationsSyncContextProvider configuration={EXPENSES_SYNC_CONFIGURATION}>
      <ExpensesList
        employeeIds={employeeIds}
        back={{ href: navigation.list.fullPath() }}
        onAddUsers={onAddUsers}
        addUsersDisabled={addUsersDisabled}
        dateFilters={dateFilters}
        setPageDateFilters={setPageDateFilters}
      />
    </IntegrationsSyncContextProvider>
  )
}

export default ExpensesListTab
